import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5020/api';

export const searchAddress = async (query) => {
  const res = await axios.get(`${API_BASE}/address-search`, { params: { q: query } });
  return res.data.localities || [];
};
